import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const usePlanCheckoutForm = (
  defaultValues: PlanCheckoutFormSchemaType,
) => {
  return useForm<PlanCheckoutFormSchemaType>({
    resolver: zodResolver(PlanCheckoutFormSchema),
    defaultValues: defaultValues,
    mode: 'onChange',
  });
};

// 필드 자체는 optional이지만, 입력이 존재한다면 validation 체크
export const PlanCheckoutFormSchema = z.object({
  zipCode: z
    .string()
    .min(5, { message: 'subscription:payment.zipCode.minErrorText' })
    .optional()
    .or(z.literal('')),
});

export type PlanCheckoutFormSchemaType = z.infer<typeof PlanCheckoutFormSchema>;
